export default __webpack_public_path__ + "static/media/beginner3.54c36f03.png";